module.exports = __webpack_public_path__ + "img/preview1.2be90d82.svg";